// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { checkSerial } from '@/asset/api/check-serial';
import { SparseAsset } from '@/asset/api/types';
import { useMutation } from '@tanstack/react-query';

/**
 * Hook for checking if a serial number exists in the system.
 *
 * @returns Mutation object with methods to check serial validity
 *
 * @example
 * ```tsx
 * const { mutateAsync: checkSerialNumber, isPending } = useCheckSerial();
 *
 * const handleCheck = async (serial: string) => {
 *   try {
 *     const asset = await checkSerialNumber(serial);
 *     if (asset) {
 *       console.log('Serial found:', asset);
 *     } else {
 *       console.log('Serial not found');
 *     }
 *   } catch (error) {
 *     console.error('Error checking serial:', error);
 *   }
 * };
 * ```
 */
export function useCheckSerial() {
  return useMutation<SparseAsset | null, Error, string>({
    mutationFn: (serial: string) => checkSerial(serial),
  });
}
